<template lang="html">
  <component :is="textComponent" :bold="bold" :adaptive="adaptive" :tag="tag">
    <!-- @slot Безымянный слот. Используется для вставки текста-->
    <slot/>
  </component>
</template>

<script>
import bimTextH1 from '@/components/text/bimTextH1/bimTextH1'
import bimTextH2 from '@/components/text/bimTextH2/bimTextH2'
import bimTextH3 from '@/components/text/bimTextH3/bimTextH3'
import bimTextH4 from '@/components/text/bimTextH4/bimTextH4'
import bimTextH5 from '@/components/text/bimTextH5/bimTextH5'
import bimTextAccent from '@/components/text/bimTextAccent/bimTextAccent'
import bimTextMain from '@/components/text/bimTextMain/bimTextMain'
import bimTextMedium from '@/components/text/bimTextMedium/bimTextMedium'
import bimTextDesc from '@/components/text/bimTextDesc/bimTextDesc'
import bimTextHint from '@/components/text/bimTextHint/bimTextHint'
import bimTextSmall from '@/components/text/bimTextSmall/bimTextSmall'

export default {
  name: 'bimText',
  props: {
    /**
     * Размерность шрифта
     * @values h1, h2, h3, h4, h5, accent, main, medium, desc, hint, small
     */
    type: {
      type: String,
      default: 'h1',
      validator (value) {
        return ['h1', 'h2', 'h3', 'h4', 'h5', 'accent', 'main', 'medium', 'desc', 'hint', 'small'].indexOf(value) !== -1
      }
    },
    /**
     * Добавить жирность
     * @values true, false
     */
    bold: {
      type: Boolean,
      default: false
    },
    /**
     * Тег обёртки
     * @values div, h1, h2, h3, h4, h5, span
     */
    tag: {
      type: String
    },
    /**
     * Изменять размер шрифта в моб версии
     * @values true, false
     */
    adaptive: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    textComponent () {
      switch (this.type) {
        case 'h1':
          return bimTextH1
        case 'h2':
          return bimTextH2
        case 'h3':
          return bimTextH3
        case 'h4':
          return bimTextH4
        case 'h5':
          return bimTextH5
        case 'accent':
          return bimTextAccent
        case 'main':
          return bimTextMain
        case 'medium':
          return bimTextMedium
        case 'desc':
          return bimTextDesc
        case 'hint':
          return bimTextHint
        case 'small':
          return bimTextSmall
        default:
          return null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
